import { FileTypes } from 'enums'

export const NO_CONTENTS_MESSAGE = 'No contents to display.'
export const ERROR_LOADING_FILE_CONTENT_MESSAGE = 'Error loading file content.'

export const validTextFilesExtensions = [
  FileTypes.TXT,
  FileTypes.LOG,
  FileTypes.JSON,
  FileTypes.CSV,
  FileTypes.HTML,
  FileTypes.TSV
]

export const checkIsTextFile = (fileExtension: string): boolean => {
  return validTextFilesExtensions.includes(fileExtension?.toLocaleLowerCase() as FileTypes)
}

export const getFileExtension = (fileName: string): string | null => {
  const match = fileName.match(/^[^?]*/)
  if (!match) return null

  const url = match[0]
  const splitFileName = url.split('.')
  return splitFileName.length ? splitFileName[splitFileName.length - 1] : null
}

export const validImageFileExtensions = [FileTypes.PNG, FileTypes.JPG, FileTypes.JPEG, FileTypes.SVG]

export const checkIsValidImageFileExtension = (fileExtension: FileTypes) => {
  return validImageFileExtensions.includes(fileExtension as FileTypes)
}

export const validBinaryFilesExtensions = [
  FileTypes.DOCX,
  FileTypes.PDF,
  FileTypes.PNG,
  FileTypes.JPG,
  FileTypes.JPEG,
  FileTypes.XLSX,
  FileTypes.XLS
]

export const checkIsBinaryFile = (fileExtension: string): boolean => {
  return validBinaryFilesExtensions.includes(fileExtension?.toLocaleLowerCase() as FileTypes)
}

export const getTextFileTestId = (fileExtension: string): string => `${fileExtension}-file-preview`
